import * as React from 'react';
import autobind from 'autobind-decorator';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Interfaces
import { ICourse, IInstituteList, IDepartmentList } from 'store/StateInterfaces';

// Components
import CoursesListInstructor, { FormType } from '../Components/CoursesListInstructor';
import Course from '../Components/Course';
import CourseEnrolmentForm from '../Components/CourseEnrolmentForm';
import CourseImportFormContainer from './CourseImportFormContainer';

// Actions
import * as actions from '../Actions/Actions';

interface IProps {
    coursesMap: Map<number, ICourse>;
    instituteList: Map<number, IInstituteList>;
    departmentList: Map<number, IDepartmentList>;
    actions: any;
};

class CoursesListInstructorPage extends React.Component<IProps, {}> {
    public componentDidMount() {
        if (this.props.coursesMap.size === 0) {
            this.props.actions.loadCoursesListRequest();
        }
        this.props.actions.getAllInstitute();
        this.props.actions.getAllDepartment();
    }


    public render() {
        let courses;
        if (this.props.coursesMap.size !== 0) {
            courses = [];
            this.props.coursesMap.forEach((course) => {
                courses.push(<Course
                    course={course}
                    publishCourse={this.props.actions.publishCourse}
                    deleteCourse={this.props.actions.deleteCourse}
                    downloadCourse={this.props.actions.downloadCourse}
                    loadArchiveStatus={this.props.actions.loadArchiveStatus}
                    deleteArchive={this.props.actions.deleteArchive}
                    toggleArchive={this.props.actions.toggleArchive}
                    key={course.id} />);
            });
        }
        if (!courses) {
            courses = <div className='no-courses-offered-alert alert alert-danger alert-dismissable bt-alert'>No courses offered yet</div>;
        }

        return <CoursesListInstructor
            toggleForm={this.toggleForm}
            form={<CourseEnrolmentForm
                addCourse={this.props.actions.addCourse}
                loadCoursesListRequest={this.props.actions.loadCoursesListRequest}
                instituteList={this.props.instituteList}
                departmentList={this.props.departmentList} />}
            courses={courses} />;
    }

    @autobind
    private toggleForm(formType: FormType) {
        this.setState({ showFormType: formType });
    }
};

interface IReduxState {
    instructorCoursesMap: Map<number, ICourse>,
    instituteList: Map<number, IInstituteList>,
    departmentList: Map<number, IDepartmentList>
};

const mapStateToProps = (state: IReduxState) => ({
    coursesMap: state.instructorCoursesMap,
    instituteList: state.instituteList,
    departmentList: state.departmentList
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CoursesListInstructorPage);
